import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=46ffaf22&scoped=true&"
import script from "./draft.vue?vue&type=script&lang=js&"
export * from "./draft.vue?vue&type=script&lang=js&"
import style0 from "./draft.vue?vue&type=style&index=0&id=46ffaf22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffaf22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ffaf22')) {
      api.createRecord('46ffaf22', component.options)
    } else {
      api.reload('46ffaf22', component.options)
    }
    module.hot.accept("./draft.vue?vue&type=template&id=46ffaf22&scoped=true&", function () {
      api.rerender('46ffaf22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/email/components/draft.vue"
export default component.exports